module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<main-layout></main-layout>"


//////////////////
// WEBPACK FOOTER
// C:/Users/krist/source/repos/FoodButtler.App/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main